import { Pipe, PipeTransform } from '@angular/core';
import { camps } from '../../models/models.generated';

@Pipe({ name: 'purchaseDescription' })
export class PurchaseDescriptionPipe implements PipeTransform {
  transform(purchase: camps.CampPurchaseInfo): string {
    let numberOfSessions = 0;
    purchase.enrolledChildren.forEach(x => numberOfSessions += x.sessionNames.length);
    let description = '';
    if (numberOfSessions === 1) {
      description = `${purchase.enrolledChildren[0].sessionNames[0]} for ${purchase.enrolledChildren[0].name}`;
      return description;
    }

    if (purchase.enrolledChildren.length === 1) {
      description = `${numberOfSessions} sessions for ${purchase.enrolledChildren[0].name}`;
    } else {
      description = `${numberOfSessions} sessions for ${purchase.enrolledChildren.length} children`;
    }

    return description;
  }
}
